import React from "react";
import { Box, Button, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";
import GvPrimaryButton from "../../../../components/GvPrimaryButton/GvPrimaryButton";
import { PAGES_PATH } from "../../../../navigation/params";
import { PREQUAL_COPY } from "../constants";

interface IPrequalErrorScreenProps {
  onRetry: () => void;
}

export const PrequalErrorScreen = ({ onRetry }: IPrequalErrorScreenProps) => {
  const navigate = useNavigate();

  return (
    <Box className="flex h-full w-full flex-col items-center justify-center px-4 text-center">
      <ErrorOutlineIcon sx={{ fontSize: 56, color: "#E5484D" }} />
      <Typography variant="h4" sx={{ fontWeight: 600, mt: 2 }}>
        {PREQUAL_COPY.ERROR_TITLE}
      </Typography>
      <Typography variant="body1" sx={{ mt: 1, color: "text.secondary" }}>
        {PREQUAL_COPY.ERROR_SUBTITLE}
      </Typography>
      <div className="mt-6 w-full max-w-xs">
        <GvPrimaryButton type="button" onClick={onRetry}>Try Again</GvPrimaryButton>
      </div>
      <Button variant="text" sx={{ mt: 1 }} onClick={() => navigate(PAGES_PATH.DASHBOARD)}>
        Back to Dashboard
      </Button>
    </Box>
  );
};

export default PrequalErrorScreen;
